import WorkModal from './WorkModal';
import React, { useState, useEffect, useRef } from 'react';
import LineOverlay from './LineOverlay'

import { useData } from '../DataProvider';

const WorkRowCard = ({ data, audio }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playPercent, setPlayPercent] = useState(0);
  const fadeTimers = useRef({ fadeIn: null, fadeOut: null });
  const { data:providerData } = useData();
  
  const trRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isPlaying) {
      const intervalId = setInterval(() => {
        if(isPlaying)
          setPlayPercent(audio.currentTime / audio.duration);
      }, 100);

      return () => clearInterval(intervalId);
    }
  }, [isPlaying,audio]);


  const fadeInAudio = (audio, duration = 1000) => {
    clearInterval(fadeTimers.current.fadeOut); // 기존 fadeOut 중지
  
    audio.volume = 0;
    audio.currentTime = 0;
    audio.play();
  
    const step = 0.05;
    const interval = duration / (1 / step);
  
    fadeTimers.current.fadeIn = setInterval(() => {
      if (audio.volume < 1) {
        audio.volume = Math.min(audio.volume + step, 1);
      } else {
        clearInterval(fadeTimers.current.fadeIn);
      }
    }, interval);
  };
  
  const fadeOutAudio = (audio, duration = 1000, callback) => {
    clearInterval(fadeTimers.current.fadeIn); // 기존 fadeIn 중지
  
    const step = 0.05;
    const interval = duration / (1 / step);
  
    fadeTimers.current.fadeOut = setInterval(() => {
      if (audio.volume > 0) {
        audio.volume = Math.max(audio.volume - step, 0);
      } else {
        clearInterval(fadeTimers.current.fadeOut);
        audio.pause();
        if (callback) callback();
      }
    }, interval);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const playAudio = () => {
    if (isModalOpen)
      return;
    if (providerData.muted)
      return;
    setIsPlaying(true);
    fadeInAudio(audio, 800); // 800ms 동안 페이드인
  }

  const stopAudio = () => {
    setIsPlaying(false);
    setPlayPercent(0);
    fadeOutAudio(audio, 800); // 800ms 동안 페이드아웃
  }

  if (windowWidth > 833) {
    return (
      <tr ref={trRef} id={data['title'] + '-row'} onMouseOver={playAudio} onMouseOut={stopAudio}>
        <th className='default-text' scope="row" style={{ width: '38%' }} onClick={openModal}>
          <img src={data['preview-filename']} alt='' style={{ width: '80px', borderRadius: '5px', marginTop: '3px', marginBottom: '3px', marginRight: '30px', marginLeft: '-5px' }}></img>
          <span>{data['title']}</span>
        </th>
        <td className='default-text grey-text' style={{ width: '38%' }} onClick={openModal}>{data['genre']}</td>
        <td className='default-text grey-text' onClick={openModal}>{data['published-date']}</td>
        <td className='default-text grey-text' onClick={openModal}>{data['running-time']}</td>
        <WorkModal isOpen={isModalOpen} onRequestClose={closeModal} data={data} />
        <LineOverlay targetElementId={data['title']+'-row'} show={isPlaying} percent={playPercent}/>
      </tr>
    );
  }
  else {
    return (
      <tr ref={trRef} id={data['title'] + '-row'}>
        <th scope="row" onClick={openModal}>
          <img src={data['preview-filename']} alt='' style={{ width: '105px', borderRadius: '5px' }}></img>
        </th>
        <td style={{ verticalAlign: 'top' }}>
          <div className='default-text'>{data['title']}</div>
          <div className='default-text grey-text' onClick={openModal}>{data['genre']}</div>
          <div className='default-text grey-text' onClick={openModal}>{data['published-date']} · {data['running-time']}</div>
        </td>
        <WorkModal isOpen={isModalOpen} onRequestClose={closeModal} data={data} />
        <LineOverlay targetElementId={data['title']+'-row'} show={isPlaying} percent={playPercent}/>
      </tr>
    )
  }
}

export default WorkRowCard;
